module.exports = {
    getImage(name) {
        return require.context(
            "./assets/",
            true,
            /$/
        )("./" + name + ".jpg");
    }
};


// WEBPACK FOOTER //
// ./src/utils.js